<template>
  <div class="astaxin-scan">
    <div class="header">
      <img class="header-img" src="/static/images/astaxin/anti.png" />
    </div>

    <div class="banner"></div>
    <img class="logo" src="/static/images/astaxin/logo.png" />

    <img class="scan-btn" src="/static/images/astaxin/scan.png" @click="scanData" />
    <img class="scan-tip" src="/static/images/astaxin/scantip.png" />
    
    <div class="query-container">
      <input type="text" v-model="antiCode" class="input-field" placeholder="输入16位数码" maxlength="16" />
      <div class="query-button" @click="queryData">查询</div>
    </div>

  </div>
</template>

<style scoped>
.astaxin-scan {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  position: relative;
}

.header {
  width: 100vw;
  height: 6vh;
  background-color: rgb(82, 30, 24);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-img {
  height: 60%;
}

.banner {
  width: 100vw;
  height: 35vh;
  background: url(/static/images/astaxin/hb.png) center center / cover no-repeat;
}

.logo {
  position: absolute;
  width: 60vw;
  top: 8vh;
  margin-left: 30px;
}

.scan-btn {
  height: 18vh;
  margin-top: 7vh;
  align-self: center;
}

.scan-tip {
  width:50vw;
  margin-top: 5vh;
  align-self: center;
}

.query-container {
  display: flex;
  border: 2px solid rgb(105, 40, 33);
  border-radius: 5px;
  overflow: hidden;
  margin-top: 5vh;
  width: 80vw;
  height: 48px;
  align-self: center;
  box-sizing: border-box;
}

.input-field {
  width: 75%;
  padding: 0 15px;
  border: none;
  font-size: 4.5vw;
  margin: 0;
  box-sizing: border-box;
  background: white;
}

.input-field:focus {
  outline: none;
}

.query-button {
  width: 25%;
  background-color: rgb(105, 40, 33);
  color: white;
  border: none;
  font-size: 4.5vw;
  cursor: pointer;
  margin: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.query-button:hover {
  background-color: rgb(105, 40, 33);
}

.rule {
  position: absolute;
  width: 20vw;
  top: 37vh;
  right: 0;
}
</style>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      antiCode: '',
      appId: 'wx885161c495be58a3',
    };
  },
  created() {
    this.getWxJs()
  },
  methods: {
    scanData() {
      // 扫码功能
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            // 通过最后一个/截取后面的内容
            var lastIndex = scanResult.lastIndexOf('/')
            if (lastIndex !== -1) {
              scanQRCode = scanResult.substring(lastIndex + 1)
            }
          }
          if (scanQRCode) {
            // 如果截取后的内容大于16位，则截取16位，否则不截取
            if (scanQRCode.length > 16) {
              this.antiCode = scanQRCode.substring(0, 16)
            } else {
              this.antiCode = scanQRCode
            }
            this.queryData()
          }
        },
        fail: res => {
          console.log('扫码失败', res)
        }
      })
    },
    queryData() {
      // 查询功能
      if (this.antiCode.length !== 16) {
        alert('请输入16位数码')
        return
      }
      this.$router.push({
        path: '/astaxin/cn',
        query: {
          c: this.antiCode
        }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay'
          ]
        })
        wx.ready(() => {
          console.log('微信JSSDK初始化成功')
        })
        wx.error((res) => {
          console.log('微信JSSDK初始化失败', res)
        })
      })
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Astaxin/Scan.vue